module.exports = __webpack_public_path__ + "img/COMBO SPIRAL RED.b211a2f.svg";